import { Box } from '@mui/material'
import CardFrom, { CardFormConfig } from '../../component/card/card-from'
import Tab from '../../component/tab/tab.component'
import { observer, useLocalObservable } from 'mobx-react-lite';
import ButtonComponent from '../../component/button/button.component';
import i18n from '../../i18n';
import CardView from '../../component/card/card-view';
import { DeliverectLogState } from './deliverect-log-state';
import ConnectProject from './deliverect-connect-project.component';
import { useEffect } from 'react';
import { MobxObjectsManager } from '../mobx-objs/mobx-manager';
import { TopBarState } from '../../component/top-bar/top-bar-state';
import { useTranslation } from 'react-i18next';
import DeliverectPage from './deliverect-log.component';
import DeliverectOrderList from './deliverect-order-list.component';


// 顶部栏数据
const topBarState = MobxObjectsManager.get(TopBarState);

const DeliverectSetting = observer(() => {
    useTranslation();
    useEffect(() => {
        // initialize
        useData.init();
        // 更新标题
        topBarState.updateDeliverectTitle()
        return () => {

        }
    }, [])
    // 数据
    const useData = useLocalObservable(() => new DeliverectLogState());

    // 表单
    const cardConfig: CardFormConfig[] = [{
        md: 12,
        columnSpacing: { xs: 2 },
        rowSpacing: 2,
        key: 'base_setting_title',
        title: i18n.t('base_setting_title'),
        actionRender: (
            <ButtonComponent
                action='SAVE'
                handleClick={() => useData.handleSave()}
                async={true}
            />
        ),
        children: [{
            key: 'client_id',
            label: 'Deliverect Client ID',
            comType: 'INPUT',
            xs: 12,
            inputIsEdited: useData.userInfo.client_id !== useData.editUserInfo.client_id,
            onChange: (e) => useData.onFormChange(e.target.value, 'client_id')
        },
        {
            key: 'client_secret',
            label: 'Deliverect Client secret',
            comType: 'INPUT',
            xs: 12,
            inputIsEdited: useData.userInfo.client_secret !== useData.editUserInfo.client_secret,
            onChange: (e) => useData.onFormChange(e.target.value, 'client_secret')
        }]
    }]
    // tab
    const tabData = [{
        title: i18n.t('deliverect_log_page_text_deliverect_log'),
    }, {
        title: i18n.t('expand_page_third_party_projects'),
    }, {
        title: i18n.t('deliverect_log_page_text_to_sent_to_shark_order_list')
    }]

    /**
     * 渲染内容
     * @returns 
     */
    const renderContent = () => {
        switch (useData.activeTabIndex) {
            case 0:
                return <DeliverectPage useData={useData} />
            case 1:
                return <ConnectProject useData={useData} />
            case 2:
                return <DeliverectOrderList useData={useData} />
        }
    }

    return (
        <Box className={'deliverect-log-page'}>
            <Box sx={{ maxWidth: 700, mb: 4 }}>
                <CardFrom
                    config={cardConfig}
                    data={useData.editUserInfo}
                />
            </Box>
            <Tab
                data={tabData}
                activeIndex={useData.activeTabIndex}
                itemStyle={{ marginLeft: 4, marginRight: 4 }}
                onClick={(index: number) => { useData.setActiveTabIndex(index) }}

            />
            <CardView
                {...{
                    className: 'mt16',
                    contentRender: renderContent()
                }}
            />
        </Box>
    )
})

export default DeliverectSetting